// extracted by mini-css-extract-plugin
module.exports = {"comp":"FixTab_comp__MiwaQ"};